import { Container, Row, Col } from "react-bootstrap";
import "./ManifestCreation.css";
import "react-datepicker/dist/react-datepicker.css";
import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"; // Import your configured axios instance
import { formatDate, formatDateReverse } from "../../utils/Utilities.js";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom



const UpdateManifestCreation = () => {
  const handleRedirect = () => {
    navigate("/GetManifestByDate");
  }

  // const [consignmentIds, setConsignmentIds] = useState(""); 

  const [selectedValues, setSelectedValues] = useState(""); // Store the selected values as string
  const GetConsignmentsToManifest_URL = "api/get-consignments-to-manifest"; // Replace with the correct API endpoint to fetch Consignments
  const [consignments, setConsignments] = useState([]); // To store list of Consignments
  const [selectedRows, setSelectedRows] = useState(new Set());

  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors


  const { auth } = useAuth();
  const [destinationFranchiseId, setDestinationFranchiseId] = useState("");
  const [weight, setWeight] = useState("");
  const [manifestDate, setManifestDate] = useState("");
  const [consignmentIds, setConsignmentIds] = useState("");

  const [responseMessage, setResponseMessage] = useState("");

  const [message, setMessage] = useState("");
  // const [manifestNumber, setManifestNumber] = useState("");
  const { manifestNumber } = useParams(); // Get the employeeId from the URL


  const axiosPrivate = useAxiosPrivate();
  const UPDATE_MANIFEST_URL = "/api/update-manifest"; // Replace with the correct API endpoint to fetch users
  const [validationError, setValidationError] = useState("");

  const GET_MANIFEST_DETAILS_URL = "api/get-manifest";
  const [manifests, setManifests] = useState([]); // To store list of users
  const [manifestId, setManifestId] = useState("");
  const [data, setData] = useState([]);
  const [ManifestconsignmentList, setManifestconsignmentList] = useState([]);
  const [CombinedDataToTable, setCombinedDataToTable] = useState([]);

  useEffect(() => {
    if (ManifestconsignmentList.length > 0) {
      const allIds = new Set(ManifestconsignmentList.map(item => item.consignment_id));
      setSelectedRows(allIds);
    }
  }, [ManifestconsignmentList]);



  useEffect(() => {
    combinedDatafunction();
  }, []);







  const fetchManifestData = async () => {
    const headers = {
      "Content-Type": "application/json",
    };
    const data = {
      // manifest_number: manifestNumber,
      manifest_number: manifestNumber,

    };
    try {

      const response = await axiosPrivate.get(GET_MANIFEST_DETAILS_URL, {
        params: data,
        headers,
        withCredentials: true, // Ensures cookies are sent with the request if needed
      });

      setManifests(response.data); // Store the fetched data into the user state
      setDestinationFranchiseId(response.data.manifest_destination_id);
      setWeight(response.data.weight);
      // setManifestDate(response.data.manifest_date); 
      const formatDate_Reverse = formatDateReverse(response.data.manifest_date);
      setManifestDate(formatDate_Reverse);
      const ids = (response.data.consignments).map(item => item.consignment_id).join(', ');
      setConsignmentIds(ids);
      setManifestId(response.data.manifest_id)
      setLoading(false); // Stop loading spinner

      // ✅ Return the whole response data
      return response.data;

    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to load data");
      setLoading(false); // Set loading to false even if there is an error
    }
  };


  useEffect(() => {
    // console.log("CombinedDataToTable updated:", CombinedDataToTable);
  }, [CombinedDataToTable]);




  const combinedDatafunction = async () => {
    const data = await fetchManifestData();
    const fetchManifestconsignmentList = data?.consignments || [];
    // console.log("Manifest Consignments new:", fetchManifestconsignmentList);
    setManifestconsignmentList(fetchManifestconsignmentList);

    const Consignments = await fetchConsignments();
    // console.log("Consignments new:", Consignments);


    const [data1, data2] = await Promise.all([fetchManifestconsignmentList, Consignments]);

    const combinedData = [...data1, ...data2];
    // console.log("combinedData :",combinedData)
    setCombinedDataToTable(combinedData)
    // console.log("setCombinedDataToTable :",CombinedDataToTable)
    return combinedData;
  }













  const fetchConsignments = async () => {
    try {
      const para = {
        franchise_id: auth.franchise_id,
      };

      const response = await axiosPrivate.get(GetConsignmentsToManifest_URL, {
        params: para,
      });


      // Safely extract an array from the response
      const consignmentsData = Array.isArray(response.data)
        ? response.data
        : response.data?.data ?? [];

      // setConsignments(consignmentsData);
      // console.log(consignmentsData)
      setLoading(false);
      // ✅ Return the whole response data
      return consignmentsData;
    } catch (error) {
      console.error("Error fetching Consignments:", error);
      setError("Failed to load Consignments");
      setLoading(false);
    }
  };









  const handleSelectFromTable = () => {
    if (selectedRows.size === 0) {
      setValidationError("Please select at least one consignment from the table.");
      return false;
    }

    const selectedData = consignments.filter((item) =>
      selectedRows.has(item.consignment_id)
    );
    const selectedDataString = selectedData
      .map((item) => `${item.consignment_id}`)
      .join(",");

    setSelectedValues(selectedDataString);
    setValidationError("");
    return true;
  };









  // Function to toggle selection of a single row
  const toggleRowSelection = (id) => {
    const newSelectedRows = new Set(selectedRows);
    if (newSelectedRows.has(id)) {
      newSelectedRows.delete(id);
    } else {
      newSelectedRows.add(id);
    }
    setSelectedRows(newSelectedRows);
  };

  // Function to toggle selection of all rows
  const toggleSelectAll = () => {
    if (selectedRows.size === consignments.length) {
      setSelectedRows(new Set()); // Deselect all
    } else {
      setSelectedRows(new Set(consignments.map((item) => item.consignment_id))); // Select all
    }
  };







  function addItemFromTableToField(consignments, selectedRows, setSelectedValues) {

    const selectedData = consignments.filter((item) =>
      selectedRows.has(item.consignment_id)
    );

    const selectedDataString = selectedData
      .map((item) => `${item.consignment_id}`)
      .join(",");

    setSelectedValues(selectedDataString);
  }


  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }

  return (
    <>

      <section className="manifestbody">
        <br />
        <div className="wrapper5">
          <span className="d-flex justify-content-end gap-2">
            <button onClick={() => window.location.reload()} type="button" className="btn btn-success d-block top-bt">
              Create New
            </button>
            <button onClick={handleRedirect} type="button" className="btn btn-success d-block top-bt">
              Manifest List
            </button>
          </span>

          {/* <button onClick={() => window.location.reload()} type="button" className="btn btn-success ms-auto d-block top-bt">Create New</button> */}
          {/* <center>
  <button className="btn reload-button" onClick={() => window.location.reload()}>
    Create New
  </button>
</center> */}
          {/* <form onSubmit={handleSubmit}> */}
          <form >
            <h3>Update Manifest Creation</h3>
            {message && (
              <div className="response-message success">
                <p>{message}</p>
                {manifestNumber && <p>Manifest Number: {manifestNumber}</p>}
              </div>
            )}
            {/* Form Fields */}
            <Row> <Col>
              <div className="input-boxs">
                <label htmlFor="destination_franchise_id">Destination franchise Id</label>
                <input
                  type="text"
                  id="destination_franchise_id"
                  placeholder=""
                  value={destinationFranchiseId}
                  onChange={(e) => setDestinationFranchiseId(e.target.value)}
                  required
                />
                {/* <i className="bx bxs-lock-alt"></i> */}
              </div>
            </Col>
              <Col>

                <div className="input-boxs">
                  <label htmlFor="weight">Weight  </label>
                  <input
                    type="text"
                    id="weight"
                    placeholder=""
                    onChange={(e) => setWeight(e.target.value)}
                    value={weight}
                    required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col>
            </Row>
            <Row><Col>
              <div className="input-boxs">
                <label htmlFor="manifest_date">Manifest Date  </label>
                <input
                  type="date"
                  id="manifest_date"
                  onChange={(e) => setManifestDate(e.target.value)}
                  value={manifestDate}
                  required
                />
                {/* <i className="bx bxs-user"></i> */}
              </div>
            </Col>
              <Col>

                <div className="input-boxs">
                  <label htmlFor="consignment_ids">Consignment IDs  </label>
                  <input
                    type="text"
                    id="consignment_ids"
                    placeholder=""
                    value={selectedValues}
                    onChange={(e) => setSelectedValues(e.target.value)}
                  // required
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                </div>
              </Col></Row>

            <center>
              {/* <button type="submit" className="btn regbutton" onClick={() => addItemFromTableToField(consignments, selectedRows, setSelectedValues)}>
        Submit button
      </button> */}

            </center>
            <center>
              <button
                type="submit"
                className="btn regbutton"
                onClick={(e) => {
                  e.preventDefault();
                  const isValid = handleSelectFromTable(); // first: collect selections & validate
                  if (isValid) {
                    const selectedData = CombinedDataToTable.filter((item) =>
                      selectedRows.has(item.consignment_id)
                    );
                    // console.log(selectedData)
                    const selectedDataString = selectedData
                      .map((item) => `${item.consignment_id}`)
                      .join(",");

                    const consignmentIdsArray = selectedDataString
                      .split(",")
                      .map((id) => parseInt(id.trim(), 10));

                    const formattedDate = formatDate(manifestDate);

                    const body = {
                      franchise_id: auth.franchise_id,
                      destination_franchise_id: destinationFranchiseId,
                      weight,
                      manifest_date: formattedDate,
                      consignment_ids: consignmentIdsArray,
                      manifest_id: manifestId,
                    };
                    // console.log(body);
                    axiosPrivate.post(UPDATE_MANIFEST_URL, body).then((response) => {
                      setMessage(response.data.message);
                      // setManifestNumber(response.data.data.manifest_number);
                      combinedDatafunction();

                    }).catch((error) => {
                      console.error("Post manifest error:", error);
                    });
                  }

                }}
              >
                Submit
              </button>
            </center>


            {validationError && (
              <div className="validation-error" style={{ color: "red", marginTop: "10px" }}>
                {validationError}
              </div>
            )}




          </form>
          <div className="table-container">
            <form>
              <table id="customers">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={toggleSelectAll}
                        checked={selectedRows.size === CombinedDataToTable.length} // Check if all rows are selected
                      />
                    </th>
                    <th>Cons. Id</th>
                    <th>AWB</th>
                    <th>Type</th>
                    <th>Goods name</th>
                    <th>Weight</th>

                    <th>Post office</th>
                    <th>Destination franchise</th>
                  </tr>
                </thead>
                <tbody>
                  {CombinedDataToTable.map((item) => (

                    <tr key={item.consignment_id}>
                      <td>
                        <center><input
                          type="checkbox"
                          checked={selectedRows.has(item.consignment_id)}
                          onChange={() => toggleRowSelection(item.consignment_id)}
                        /></center>
                      </td>
                      <td>{item.consignment_id}</td>
                      <td>{item.awb_number}</td>
                      <td>{item.consignment_type}</td>
                      <td>{item.goods_name}</td>
                      <td>{item.weight}</td>
                      <td> {item.post_office} - {item.pincode}</td>
                      <td>{item.consignment_destination_franchise_code} - {item.consignment_destination_franchise}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </form>
          </div>

        </div>

        {/* Display API Response */}

      </section>




      <TopBar />

    </>
  );
};

export default UpdateManifestCreation;
